import React from 'react'
import { ContentBody, ContentHeader, RowSection, SectionContent } from '../layout'
import DataRow from './DataRow'
import { emptyValue, formatDateTime } from './helpers'
import { IOtaReservation } from 'static/interfaces'

interface IProps {
  otaReservation: IOtaReservation
}
const SystemSectionContent = ({ otaReservation }: IProps) => {
  return (
    <SectionContent>
      <ContentHeader>基本情報</ContentHeader>
      <ContentBody className="single-column">
        <RowSection>
          <DataRow label="id" content={otaReservation.id} />
          <DataRow label="status" content={emptyValue(otaReservation.booking_status_id)} />
          <DataRow label="created_at" content={formatDateTime(otaReservation.created_at)} />
          <DataRow label="updated_at" content={formatDateTime(otaReservation.updated_at)} />
          <DataRow label="sales_channel" content={emptyValue(otaReservation.seller)} />
          <DataRow
            label="jwt_reservation_id"
            content={otaReservation.jwt_reservation_id ? otaReservation.jwt_reservation_id : '-'}
          />
        </RowSection>
      </ContentBody>
    </SectionContent>
  )
}

export default SystemSectionContent
